module.exports = __webpack_public_path__ + "img/home_credit_scoring.c2d05247.png";